import { sendMessageToFlutter } from "../bridge";
import { FlutterChannel } from "../enums/channel";

/**
 * Opens the dialog to review the app
 */
export function requestAppReview(): void {
  sendMessageToFlutter(FlutterChannel.REQUEST_APP_REVIEW);
}

export function openStoreListing(): void {
  sendMessageToFlutter(FlutterChannel.OPEN_STORE_LISTING);
}

/**
 * Tries to open the native review dialog, falls back to the store listing
 */
export function requestAppReviewOrStoreListing(): void {
  if (window.appReviewAvailable) {
    requestAppReview();
  } else {
    openStoreListing();
  }
}
